import HomeFilled from '@/assets/home-fill.svg?react';

import NewFill from '@/assets/new-fill.svg?react';

import OrderFill from '@/assets/order-fill.svg?react';

import UserFill from '@/assets/user-fill.svg?react';

import type { ReactNode } from 'react';

interface MenuItem {
  title: string;
  path: string;
  icon: ReactNode;
  key: string;
}

export const menuItems: MenuItem[] = [
  {
    title: 'Главная',
    path: '/',
    icon: <HomeFilled className="size-11" />,
    key: 'home',
  },
  {
    title: 'Создать',
    path: '/new-ad',
    icon: <NewFill className="size-11" />,
    key: 'create',
  },
  {
    title: 'Заказы',
    path: '/orders',
    icon: <OrderFill className="size-11" />,
    key: 'orders',
  },
  {
    title: 'Профиль',
    path: '/profile',
    icon: <UserFill className="size-11" />,
    key: 'profile',
  },
];
